export default __webpack_public_path__ + "static/aymen-a0f465b1c714229a82e8d0c26c3e3aa5.jpg";